import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import DialogLine from './components/DialogLine';
import useSecuences from './hooks/useSecuences';
import classes from './Game.module.scss';
import PlayPauseButton from './components/PlayPauseButton';
import FinishButton from './components/FinishButton';
import { stagger, useAnimate, motion } from 'framer-motion';

function getLimitAnimateLines() {
  const height = window.innerHeight

  if (height > 1080) return 15
  if (height > 800) return 10
  return 8
}

const DELAY_START_PLAY = 2000;

const Game = forwardRef(function Game({ onAnswer }, ref) {
  const secuences = useSecuences();
  const [playing, setPlaying] = useState(false);
  const [lineSelected, setLineSelected] = useState(secuences[0]);
  const [containerRef, anima] = useAnimate();
  const [showFinish, setShowFinish] = useState(false);
  const dialogsRefs = useRef({})

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      const sequence = [
        ["[data-animate-id='line']", { opacity: 1, y: 0 }, { delay: stagger(0.15), duration: .5 }],
        ["[data-animate-id='play-pause']", { opacity: 1 }, { duration: .5 }]
      ]

      await anima(sequence)

      setTimeout(() => {
        setPlaying(true)
      }, DELAY_START_PLAY)
    },
    animateExit: async () => {
      setPlaying(false)
    }
  }));

  const handleEndLine = (index) => {
    if (index === secuences.length - 1) {
      setPlaying(false);
      setShowFinish(true);
    } else {
      setLineSelected(secuences[index + 1]);
    }
  }

  useEffect(() => {
    if (!playing) return

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const scrollOptions = isChrome
      ? { behavior: "smooth", block: "start", inline: "nearest" }
      : { behavior: "smooth", block: "nearest", inline: "nearest" }

    dialogsRefs.current[lineSelected.id]?.scrollIntoView(scrollOptions);
  }, [lineSelected, playing])

  const limitAnimateLines = getLimitAnimateLines()

  return (
    <div ref={containerRef} className={classes.scrollY}>
      <div className={classes.list}>
        {secuences.map((secuence, index) => (
          <motion.div
            data-animate-id={index < limitAnimateLines ? 'line' : null}
            key={secuence.id}
            style={index < limitAnimateLines ? { opacity: 0, y: 500 } : null}
          >
            <DialogLine
              ref={ref => dialogsRefs.current[secuence.id] = ref}
              selected={lineSelected.id === secuence.id}
              reverse={index % 2 === 0}
              author={secuence.author}
              onClick={() => {
                setLineSelected(secuence);
                setPlaying(true);
              }}
              paused={!playing}
              onEnded={() => handleEndLine(index)}
              media={secuence.media}
              text={secuence.text}
            />
          </motion.div>
        ))}
      </div>

      <motion.div
        data-animate-id="play-pause"
        style={{ opacity: 0 }}
        className={classes.navBar}
      >
        <PlayPauseButton playing={playing} onClick={() => setPlaying(!playing)} />

        {showFinish && (
          <div className={classes.floatRight}>
            <motion.div
              style={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <FinishButton onClick={() => onAnswer(true)} />
            </motion.div>
          </div>
        )}
      </motion.div>
    </div>
  )
})

export default Game